import { render, staticRenderFns } from "./szks-result-list.vue?vue&type=template&id=3bad7f84&"
import script from "./szks-result-list.vue?vue&type=script&lang=ts&"
export * from "./szks-result-list.vue?vue&type=script&lang=ts&"
import style0 from "./szks-result-list.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports